import { useEffect, useState, useRef } from 'react';
import ServiceList from '../../components/ServiceList/ServiceList';
import FilterButtons from '../../components/FilterButtons/FilterButtons';
import CreateService from '../../components/CreateService/CreateService';
import { Button } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import './details.css';
import { useSearchParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu';
export function Default() {
  const [ip, setIP] = useState('');
  const [name, setName] = useState('');
  const searchRef = useRef();
  const onChange = (searchTerm) => {
    setIP('');
    setName('');
  };
  const onSearch = (event) => {
    if (searchRef.current.value === '') {
      setIP('');
      setName('');
      return;
    }
    const value = searchRef.current.value;
    isNaN(value.charAt(0)) ? setName(value) : setIP(value);
  };
  //Getting params from url for filtering servicelist
  const [searchParams] = useSearchParams();
  const getFilter = () => {
    const projects = searchParams.get('project');
    const envs = searchParams.get('env');
    const Status = searchParams.get('status');
    const servicetype = searchParams.get('stype');
    let newfilter = {};
    if (projects !== null) {
      newfilter.project = projects.split(',');
    } else {
      newfilter.project = [];
    }
    if (envs !== null) {
      newfilter.env = envs.split(',');
    } else {
      newfilter.env = [];
    }
    if (servicetype !== null) {
      newfilter.Servicetype = servicetype.split(',');
    } else {
      newfilter.Servicetype = [];
    }
    if (Status !== null) {
      newfilter.status = [parseInt(Status)];
    } else {
      newfilter.status = [];
    }
    return newfilter;
  };

  const [filter, setFilters] = useState(getFilter());
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    setFilters(getFilter());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  return (
    <div className="topDiv">
      {anchorEl && (
        <div className="popper">
          <CreateService anchorEl={anchorEl} onClose={handleClick} />
        </div>
      )}
      <div className="paddingButton">
        <Hamburger />
        <div className="topButtons">
          <h1> Service Monitor </h1>
          <div className="subtop">
            <div className="allbuttons">
              <div className="search-bar">
                <input type="text" ref={searchRef} onChange={onChange} placeholder="Search by IP and Name" />
                <button onClick={onSearch}>
                  <SearchIcon />
                </button>
              </div>
              <FilterButtons
                pro={filter?.project}
                env={filter?.env}
                status={filter?.status}
                servicetype={filter?.Servicetype}
              />
              <div className="addservicebutton">
                <button onClick={handleClick}>
                  <AddBoxIcon size="small" />
                  Add Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ServiceList
        projects={filter?.project}
        env={filter?.env}
        status={filter?.status}
        ip={ip}
        stype={filter?.Servicetype}
        name={name}
      />
    </div>
  );
}
